import { css } from 'lit';

import { stacked } from '../media.js';

export const templateEditorPageStyles = css`
  form {
    display: grid;
    gap: var(--column-gap);
    grid-template-columns: var(--columns-aside-main);
    align-items: start;
  }

  @media ${stacked} {
    form {
      grid-template-columns: minmax(0, 1fr);
    }
  }

  .copies {
    margin-bottom: var(--column-gap);
  }

  .buttons {
    grid-column: 1 / -1;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: var(--space-2);
    position: sticky;
    bottom: var(--bottom-overlay);
    /* Clear of the home indicator, unless the update prompt already covers it. */
    padding: var(--space-3) 0 calc(var(--space-3) + max(0px, var(--safe-bottom) - var(--bottom-overlay)));
    border-top: var(--border-width) solid var(--border);
    background: var(--background);
  }

  textarea {
    min-height: var(--textarea-min-height);
  }

  form section + section {
    margin-top: 0;
  }
`;
